import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto text-center relative overflow-hidden rounded-3xl">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20soft%20golden%20flowing%20gradients%20and%20elegant%20light%20streaks%2C%20luxurious%20dark%20theme%20with%20warm%20amber%20accents%2C%20minimalist%20composition%20suitable%20for%20call%20to%20action%20section&width=1200&height=500&seq=cta-bg-001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        </div>

        <div className="relative z-10 py-16 md:py-20 px-6 md:px-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
            准备好开启<span className="text-primary-400">高清观影</span>之旅了吗？
          </h2>
          <p className="text-sm md:text-base text-white/70 mb-8 max-w-lg mx-auto leading-relaxed">
            即刻加入BaoyuTV，畅享海量高清影视资源。新用户注册即享7天免费会员体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/drama"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base cursor-pointer hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              立即体验
            </Link>
            <Link
              to="/article/baoyutv-huiyuanquanyi"
              className="px-8 py-3.5 rounded-full border-2 border-white/30 text-white font-semibold text-base cursor-pointer hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
            >
              了解会员权益
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}